import React from "react";
import { default as MUIFormGroup } from "@mui/material/FormGroup";
import styled from "styled-components";

const StyledMUIFormGroup = styled(MUIFormGroup)``;

export const FormGroup = (props) => {
  return <StyledMUIFormGroup {...props} />;
};
